import { Injectable } from '@angular/core';
import { HttpClient ,HttpHeaders} from '@angular/common/http';
import { HttpClientHelper } from 'src/app/cores/httpClientHelper';
import { JwtHelperService } from '@auth0/angular-jwt';


@Injectable({providedIn: 'root'})
export class AuthService {
   


    constructor(private httpClient: HttpClient) { }

    login(model:any) {
        console.log(model);
       return this.httpClient.post<any>(HttpClientHelper.baseURL+"users/login",model);
    }

    get isLoggedIn() {
        return this.isAuthorized;
    } 

    isAuthorized():boolean{
        const helper = new JwtHelperService();

        let token = localStorage.getItem("auth_token");
        if (token != null) {
            helper
            if (helper.isTokenExpired(token)) {
                localStorage.removeItem("auth_token");
                return false;
            }else{
                return true;
            }
        }else{

          return false;
        }
    }

    userFullname():string {
        const helper = new JwtHelperService();
        const fullname = helper.decodeToken(localStorage.getItem("auth_token"))
        return fullname["fullname"]== null ? "User":fullname["fullname"];
    }
    userAvatar():string {
        const helper = new JwtHelperService();
        const fullname = helper.decodeToken(localStorage.getItem("auth_token"));

        return HttpClientHelper.imageUrl + (fullname["avatar"]== null ? "no image":fullname["avatar"]);
    }

    isMainOfficeId():string {
        const helper = new JwtHelperService();
        const decodeToken = helper.decodeToken(localStorage.getItem("auth_token"))
        return decodeToken["isMain"];      
    }
    percentage():number {
        const helper = new JwtHelperService();
        const decodeToken = helper.decodeToken(localStorage.getItem("auth_token"))
        return decodeToken["percent"];      
    }
    
    officeId():number {
        const helper = new JwtHelperService();
        const decodeToken = helper.decodeToken(localStorage.getItem("auth_token"))
        return decodeToken["officeId"];        
    }

    format():string {
        const helper = new JwtHelperService();
        const format = helper.decodeToken(localStorage.getItem("auth_token"))
        return format["format"];
    }

    timeZone():string {
        const helper = new JwtHelperService();
        const format = helper.decodeToken(localStorage.getItem("auth_token"))
        return format["timeZone"];
    }

    //0 miladi
    //1 shamsi

    
    signOutSite() {
        localStorage.removeItem('auth_token');
    }


    // item:any = {
    //     "name": "QASSEM SULEIMANI",
    //     "first_name": "QASSEM",
    //     "middle_name": "",
    //     "last_name": "SULEIMANI"
    //   }
    // getSancation(){
    //     return this.httpClient.post<any>("https://namescan.io/api/v1/person-scans/sanction",this.item,{headers:this.getHeader()})
    // }


    // getHeader() {
    //     let headers: HttpHeaders = new HttpHeaders();
    //         headers = headers.append('Content-Type', 'application/json');
    //         headers = headers.append('api-key', '5D28979E99054A2EA4CA10D3D5BC6F0B');
    //         return headers;
    // }
}